<template>
  <main class="pb-8">
    <p class="font-semibold text-brand-black font-cooper text-lg">
      {{ generateGreetings }}, {{ userDetails.name.split(' ').slice(0, 1).toString() }}.
    </p>

    <div v-if="!pageLoaded" class="flex justify-center items-center">
      <div role="status">
        <svg
          aria-hidden="true"
          class="inline w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-red-600"
          viewBox="0 0 100 101"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
            fill="currentColor"
          />
          <path
            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
            fill="currentFill"
          />
        </svg>
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div>
      <div class="">
        <Checklist />
      </div>

      <div class="grid md:grid-cols-3 gap-4 mt-3 mb-8">
        <job-summary-card label="Total Jobs" :count="totalJobs?.meta?.total || 0" job />
        <job-summary-card label="Total Talents" :count="totalTalents?.meta?.total || 0" job />
        <job-summary-card label="Employees" :count="teams.members?.length || 0" job />
      </div>

      <!-- <div
        class="snap-x mt-8 p-3 flex items-center justify-between space-x-3 overflow-x-auto md:overflow-x-scroll scrollbar-hide"
      >
        <div
          class="snap-proximity snap-center flex-shrink-0 w-4/5 md:w-[32%] md:flex-shrink-1 flex flex-col p-6 rounded-lg shadow border border-[#F2F2F2] bg-brand-button"
        >
          <div class="flex justify-between items-center">
            <span class="font-bold text-white text-xl">Total Jobs</span>
          </div>
          <div class="mt-5">
            <span class="text-xl lg:text-4xl font-normal lg:font-bold text-white">{{
              totalJobs?.meta?.total || 0
            }}</span>
          </div>
        </div>
        <div
          class="snap-proximity snap-center flex-shrink-0 w-4/5 md:w-[32%] md:flex-shrink-1 flex flex-col p-6 rounded-lg shadow border border-[#F2F2F2] bg-[#F9F871]"
        >
          <div class="flex justify-between items-center">
            <span class="font-bold text-xl">Total Talents</span>
          </div>
          <div class="mt-5">
            <span class="text-xl lg:text-4xl font-normal lg:font-bold">{{
              totalTalents?.meta?.total || 0
            }}</span>
          </div>
        </div>
        <div
          class="snap-proximity snap-center flex-shrink-0 w-4/5 md:w-[32%] md:flex-shrink-1 flex flex-col p-6 rounded-lg shadow border border-[#F2F2F2] bg-brand-side"
        >
          <div class="flex justify-between items-center">
            <span class="font-bold text-white text-xl">EMPLOYEES</span>
          </div>
          <div class="mt-5">
            <span class="text-xl lg:text-4xl text-white font-normal lg:font-bold">
              {{ teams.members?.length || 0 }}
            </span>
          </div>
        </div>
      </div> -->

      <!-- <TalentCard /> -->
      <JobCard class="mb-8" />
    </div>
  </main>
</template>

<script setup>
import JobSummaryCard from '@/components/job/JobSummaryCard.vue';
import { ref, computed, onMounted } from 'vue';
import moment from 'moment';
import { useStore } from 'vuex';
import JobCard from '@/components/JobCard.vue';
import TalentCard from '@/components/TalentCard.vue';
import Checklist from '@/components/partials/Checklist.vue';

const teams = ref({
  members: [],
  invites: [],
});
const store = useStore();
const pageLoaded = ref(false);

async function getTeams() {
  try {
    teams.value = await store.dispatch('auth/getTeamMembers', { forceReload: true });
  } catch (error) {
    toast.error(errorMessage(error) || 'Something went wrong (Please check internent connection)', {
      timeout: 5000,
      hideProgressBar: true,
    });
  } finally {
    pageLoaded.value = true;
  }
}

const generateGreetings = computed(() => {
  const currentHour = moment().format('HH');
  if (currentHour >= 3 && currentHour < 12) {
    return 'Good Morning';
  } else if (currentHour >= 12 && currentHour < 15) {
    return 'Good Afternoon';
  } else if (currentHour >= 15 && currentHour < 20) {
    return 'Good Evening';
  } else if (currentHour >= 20 && currentHour < 3) {
    return 'Good Night';
  } else {
    return 'Hello';
  }
});

const userDetails = computed(() => {
  return store.state.auth.userDetails;
});

const totalTalents = computed(() => {
  return store.getters['global/getTalentsPayload'];
});

const totalJobs = computed(() => {
  return store.getters['global/getJobsPayload'];
});

onMounted(async () => {
  await Promise.all([
    store.dispatch('auth/getUser', { forceReload: true }),
    store.dispatch('global/getAllJobs'),
    store.dispatch('global/getAllTalents'),
    store.dispatch('global/getSubscriptionPayments'),
    getTeams(),
  ]).finally(() => {
    pageLoaded.value = true;
  });
});
</script>
